module.exports = __webpack_public_path__ + "static/media/flow-monitor-action-alert.e14b58ba.svg";